<template>
  <div class="page">
    <div class="page__bd">
      <div class="form-preview weui-form-preview">
        <div class="weui-form-preview__hd">
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">单据编号</label>
            <em class="weui-form-preview__value">{{form.main.brc_code}}</em>
          </div>
        </div>
        <custom-layout class="weui-form-preview__bd" :view-config="customViewConfig">
          <div class="weui-form-preview__item" slot="brc_date">
            <label class="weui-form-preview__label">{{customLabel.brc_date || "异动日期"}}</label>
            <span class="weui-form-preview__value" v-format="'yyyy-MM-dd'">{{form.main.brc_date}}</span>
          </div>
          <div class="weui-form-preview__item" slot="brc_kind">
            <label class="weui-form-preview__label">{{customLabel.brc_kind || "异动类型"}}</label>
            <span class="weui-form-preview__value">{{form.main.brc_kind}}</span>
          </div>
          <div class="weui-form-preview__item" slot="brc_custname">
            <label class="weui-form-preview__label">{{customLabel.brc_custname || "客户名称"}}</label>
            <span class="weui-form-preview__value">{{form.main.brc_custname}}</span>
          </div>
          <div class="weui-form-preview__item" slot="brc_currency">
            <label class="weui-form-preview__label">{{customLabel.brc_currency || "币别"}}</label>
            <span class="weui-form-preview__value">{{form.main.brc_currency}}</span>
          </div>
          <div class="weui-form-preview__item" slot="brc_amount">
            <label class="weui-form-preview__label">{{customLabel.brc_amount || "票据金额"}}</label>
            <span class="weui-form-preview__value" v-format="'¥#,##0.00'">{{form.main.brc_amount}}</span>
          </div>
          <div class="weui-form-preview__item" slot="brc_paykind" v-if="form.main.brc_paykind"> 
            <label class="weui-form-preview__label">{{customLabel.brc_paykind || "付款类型"}}</label>
            <span class="weui-form-preview__value">{{form.main.brc_paykind}}</span>
          </div>
          <div class="weui-form-preview__item" slot="brc_vendname" v-if="form.main.brc_vendname"> 
            <label class="weui-form-preview__label">{{customLabel.brc_vendname || "受让人"}}</label>
            <span class="weui-form-preview__value">{{form.main.brc_vendname}}</span>
          </div>
          <div class="weui-form-preview__item" slot="brc_ppcode" v-if="form.main.brc_ppcode"> 
            <label class="weui-form-preview__label">{{customLabel.brc_ppcode || "来源单号"}}</label>
            <span class="weui-form-preview__value">{{form.main.brc_ppcode}}</span>
          </div>
          <div class="weui-form-preview__item" slot="brc_ppclass" v-if="form.main.brc_ppclass"> 
            <label class="weui-form-preview__label">{{customLabel.brc_ppclass || "来源类型"}}</label>
            <span class="weui-form-preview__value">{{form.main.brc_ppclass}}</span>
          </div>
          <div class="weui-form-preview__item" slot="brc_reason"> 
            <label class="weui-form-preview__label">{{customLabel.brc_reason || "变动原因"}}</label>
            <span class="weui-form-preview__value">{{form.main.brc_reason}}</span>
          </div>
          <div class="weui-form-preview__item" slot="brc_barcode"> 
            <label class="weui-form-preview__label">{{customLabel.brc_barcode || "来源应收票据"}}</label>
            <span class="weui-form-preview__value">{{form.main.brc_barcode}}</span>
          </div>
        </custom-layout>
      </div>

      <div class="form-preview weui-form-preview" v-if="form.items.length>0">
        <div class="weui-form-preview__bd form-detail-preview" v-for="item in form.items" :key="item.id">
          <div class="form-detail-preview_num">{{item.bcd_detno}}</div>
           <custom-layout :view-config="customViewConfig" position="detail1">
            <div class="weui-form-preview__item" slot="bcd_sourcecode">
              <label class="weui-form-preview__label">{{customLabel.bcd_sourcecode || "来源单号"}}</label>
              <span class="weui-form-preview__value">{{item.bcd_sourcecode}}</span>
            </div>
            <div class="weui-form-preview__item" slot="bcd_sourcetype">
              <label class="weui-form-preview__label">{{customLabel.bcd_sourcetype || "来源类型"}}</label>
              <span class="weui-form-preview__value">{{item.bcd_sourcetype}}</span>
            </div>
            <div class="weui-form-preview__item" slot="bcd_amount">
              <label class="weui-form-preview__label">{{customLabel.bcd_amount || "本次异动金额(元)"}}</label>
              <span class="weui-form-preview__value">{{numberFormat(item.bcd_amount,'¥#,##0.00')}}</span>
            </div>
            
           </custom-layout>
        </div>
      </div>

      <div class="form-preview weui-form-preview">
        <div class="weui-form-preview__bd">
          <div class="weui-form-preview__item" v-if="form.main.brc_remark">
            <label class="weui-form-preview__label">备注</label>
            <span class="weui-form-preview__value">{{form.main.brc_remark}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">录入人</label>
            <span class="weui-form-preview__value">{{form.main.creatorName}}</span>
          </div>
          <div class="weui-form-preview__item" v-if="form.main.brc_auditman">
            <label class="weui-form-preview__label">审核人</label>
            <span class="weui-form-preview__value">{{form.main.brc_auditman}}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CustomLayout from "@/components/layout/CustomLayout.vue";
import process from "@/mixins/process.js";

export default {
  mixins: [process],
  components: {
    CustomLayout,
  },
  data() {
    return {
      baseUrl: "/api/money/billarchange",
      caller: "BillARChange",
      xtype: "money-billarchange-formpanel",
    };
  },
};
</script>
